export const { csrfTokenName } = window.$app;
export const { csrfTokenValue } = window.$app;
export const { devMode } = window.$app;

export default {
    csrfTokenName,
    csrfTokenValue,
    devMode,
};



// WEBPACK FOOTER //
// ./assets/js/craft.js